import { toast } from 'sonner';
import i18n from '../i18n';
import {
  describeRuleReferenceBlockedError,
  getLibraryQuestionText,
  getRuleReferenceBlockedError,
} from './ruleReferenceBlockedError';

export const RULE_BLOCKED_TOAST_DURATION_MS = 10_000;

type TToastError = (title: string, options: { description: string; duration: number }) => unknown;

/**
 * Shows a save error caused by one of a question's rules as a titled toast that stays up long enough to read,
 * and returns whether it did — so the caller can fall back to its own toast for any other error.
 */
export function toastRuleReferenceBlockedError(
  e: unknown,
  library: Record<string, unknown>,
  showError: TToastError = toast.error,
  t: (key: string, options?: Record<string, unknown>) => string = i18n.t.bind(i18n),
): boolean {
  const error = getRuleReferenceBlockedError(e);
  if (!error) return false;

  const { title, description } = describeRuleReferenceBlockedError(
    error,
    t,
    getLibraryQuestionText(library, error.targetQuestionId),
  );
  showError(title, { description, duration: RULE_BLOCKED_TOAST_DURATION_MS });
  return true;
}
